// gift-card-fathers-day-preview.js — live-bind the voucher preview to the purchase form.
// Reads form fields (amount select, recipient name, message) and mirrors them into the
// preview panel. No app SDK dependency; pure DOM. Falls back to placeholder text when empty.
(function () {
  var root = document.querySelector("[data-gcp-preview]");
  if (!root) return;

  var amountOut = root.querySelector("[data-preview-amount]");
  var nameOut = root.querySelector("[data-preview-name]");
  var msgOut = root.querySelector("[data-preview-message]");

  var namePlaceholder = nameOut ? nameOut.textContent : "";
  var msgPlaceholder = msgOut ? msgOut.textContent : "";

  var amountIn = document.querySelector("#gcpAmount");
  var nameIn = document.querySelector("#gcpRecipientNameValue"); // combined first+last (hidden)
  var msgIn = document.querySelector("#gcpRecipientMsgField");

  function syncAmount() {
    if (!amountIn || !amountOut) return;
    var opt = amountIn.options[amountIn.selectedIndex];
    if (opt && opt.dataset.price) amountOut.textContent = opt.dataset.price;
  }

  // The woven label carries an initial and surname — "John Smith" reads as "J. SMITH".
  // Display only: properties[Recipient name] keeps the full name, since that is what
  // Shopify puts on the gift card and in the email to the recipient.
  function labelName(full) {
    var parts = full.split(/\s+/).filter(Boolean);
    if (parts.length < 2) return full.toUpperCase();
    var last = parts[parts.length - 1];
    return (parts[0].charAt(0) + ". " + last).toUpperCase();
  }

  function syncName() {
    if (!nameIn || !nameOut) return;
    var v = nameIn.value.trim();
    nameOut.textContent = v ? labelName(v) : namePlaceholder;
  }

  function syncMessage() {
    if (!msgIn || !msgOut) return;
    var v = msgIn.value.trim();
    msgOut.textContent = v ? v : msgPlaceholder;
  }

  if (amountIn) {
    amountIn.addEventListener("change", syncAmount);
    syncAmount();
  }
  if (nameIn) {
    nameIn.addEventListener("input", syncName);
    syncName();
  }
  if (msgIn) {
    msgIn.addEventListener("input", syncMessage);
    syncMessage();
  }
})();